var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#69B045",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.155,
    d: "M10.289 20.898c.204.07.41.135.618.196.153.045.308.083.462.123.003 0 .004 0 .005.002.085.021.167.046.25.065.014-.066.023-.134.035-.2l.004-.024c.028-.155.056-.311.08-.466.033-.213.059-.426.082-.637.133-1.185.134-2.348.014-3.477-.29-2.684-1.276-5.165-2.835-7.251-.178-.238-.361-.47-.554-.697-.164-.194-.333-.385-.506-.57C5.998 5.893 3.41 4.337.337 3.54c-.658 3.111-.329 6.17.784 8.868.098.238.203.474.313.706.129.271.264.537.41.8 1.271 2.306 3.153 4.265 5.504 5.649.913.536 1.895.986 2.941 1.335zM14.798 20.898c-.204.07-.41.135-.619.196-.153.045-.307.083-.461.123-.003 0-.005 0-.006.002-.084.021-.166.046-.25.065-.013-.066-.022-.134-.034-.2l-.005-.024c-.027-.155-.055-.311-.08-.466-.032-.213-.058-.426-.082-.637-.133-1.185-.134-2.348-.013-3.477.29-2.684 1.275-5.165 2.835-7.251.178-.238.36-.47.553-.697.164-.194.333-.385.507-.57 1.946-2.069 4.533-3.625 7.607-4.422.658 3.111.328 6.17-.784 8.868-.098.238-.203.474-.313.706-.129.271-.265.537-.41.8-1.271 2.306-3.153 4.265-5.504 5.649-.914.536-1.895.986-2.941 1.335z",
    transform: "translate(1.943 .55)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A8254",
    d: "M11.499 20.065c.134.171.272.34.415.507.105.122.214.24.322.358l.004.005c.059.065.115.13.175.193.046-.048.09-.1.135-.149.006-.005.01-.012.016-.018.107-.114.214-.23.316-.347.14-.16.276-.324.409-.488.743-.92 1.363-1.896 1.863-2.909 1.186-2.411 1.681-5.037 1.483-7.65-.023-.298-.053-.594-.094-.891-.035-.253-.074-.506-.122-.759-.532-2.81-1.876-5.546-4.031-7.917-2.21 2.246-3.562 4.994-4.066 7.872-.044.254-.081.51-.113.766-.037.298-.064.597-.083.897-.16 2.637.377 5.322 1.613 7.783.48.955 1.067 1.876 1.758 2.747",
    transform: "translate(1.943 .55)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpa);
export default __webpack_public_path__ + "static/media/spa.64c833acf8831122b59343b506efff90.svg";
export { ForwardRef as ReactComponent };